import React from 'react';
import { IconButton } from '@producer/ui-kit';
import { Cross2Icon } from '@radix-ui/react-icons';

import styles from './modal-header.module.scss';
type ModalHeaderProps = {
  title: string | React.ReactNode;
  onClose?: () => void;
  action?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
  className?: string;
};

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  onClose,
  action,
  onAction,
  actionDisabled,
}) => {
  return (
    <header className={styles['header']}>
      {!!onClose && (
        <div className={styles['close-item']}>
          <IconButton icon={<Cross2Icon />} onClick={onClose} />
        </div>
      )}

      <h1>{title}</h1>

      <span className={styles['action']} onClick={onAction} data-disabled={actionDisabled}>
        {action}
      </span>
    </header>
  );
};
